import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Parish boundary map (Lookup Tool profile page). Progressive enhancement: the
// container is rendered empty by Twig; we fetch the parish's boundary GeoJSON from
// our server endpoint and draw it on a clean CARTO Positron basemap. If the parish
// has no boundary (e.g. extra-parochial places) or the fetch fails, we hide the
// container so the page is unaffected.
//
// CARTO require an API key on their raster basemaps. The key is a public client-side
// token, passed down from CARTO_BASEMAP_KEY via the template's data-tile-key, and is
// domain-restricted at CARTO's end: on a host outside that allowlist every tile 403s
// and the map renders blank. Unkeyed tiles still serve (watermarked), so on the first
// tile error we drop the key and reload the layer without it.
const CARTO_POSITRON_TILES =
  "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attributions">CARTO</a>';

const parishMapContainer = document.querySelector("[data-parish-map]");

if (parishMapContainer && parishMapContainer.dataset.boundaryUrl) {
  const { boundaryUrl, tileKey } = parishMapContainer.dataset;

  fetch(boundaryUrl, { headers: { Accept: "application/json" } })
    .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
    .then((geojson) => {
      if (!geojson.features || geojson.features.length === 0) {
        parishMapContainer.hidden = true;
        return;
      }

      const map = L.map(parishMapContainer, {
        scrollWheelZoom: false, // don't trap page scroll
        attributionControl: true,
      });

      const basemapOptions = { attribution: CARTO_ATTRIBUTION, maxZoom: 19 };
      const basemap = L.tileLayer(
        tileKey
          ? `${CARTO_POSITRON_TILES}?key=${encodeURIComponent(tileKey)}`
          : CARTO_POSITRON_TILES,
        basemapOptions,
      ).addTo(map);

      if (tileKey) {
        basemap.once("tileerror", () => {
          map.removeLayer(basemap);
          L.tileLayer(CARTO_POSITRON_TILES, basemapOptions).addTo(map);
        });
      }

      const boundary = L.geoJSON(geojson, {
        style: {
          color: "#0273B8",
          weight: 2,
          fillColor: "#0273B8",
          fillOpacity: 0.25,
        },
      }).addTo(map);

      map.fitBounds(boundary.getBounds(), { padding: [16, 16] });
    })
    .catch(() => {
      parishMapContainer.hidden = true;
    });
}
